import Reveal from './Reveal';
import { heroFacts } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative pt-28 md:pt-40 pb-16 md:pb-28">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Reveal>
            <div className="flex flex-col">
              <span className="inline-flex items-center gap-2 self-start px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs tracking-wider mb-6">
                <i className="ri-bookmark-3-line text-sm"></i>
                人物专题 · 百科式资料
              </span>

              <h1 className="font-heading font-bold text-foreground-950 leading-tight text-3xl md:text-5xl">
                玩偶姐姐是谁？
                <br />
                <span className="text-primary-600">个人资料与真实身份</span>揭秘
              </h1>

              <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
                如果你第一次听说这个名字，或者想快速补全她的背景资料，这里把「她是谁、从哪来、怎么走红」整理成一篇可顺序阅读的合集。
              </p>

              <div className="mt-8 flex flex-wrap items-center gap-3">
                <a
                  href="#index"
                  className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  打开专题索引
                </a>
                <a
                  href="#profile"
                  className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  先看人物档案
                </a>
              </div>

              <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-xl">
                {heroFacts.map((fact) => (
                  <div key={fact.label} className="border-l-2 border-background-300 pl-3">
                    <dt className="text-xs text-secondary-700 mb-1">{fact.label}</dt>
                    <dd className="text-sm font-medium text-foreground-900">{fact.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <figure className="relative w-full h-[420px] md:h-[560px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20magazine%20cover%20portrait%20of%20an%20elegant%20faceless%20silhouette%20figure%20in%20soft%20warm%20amber%20light%20against%20a%20textured%20cream%20paper%20studio%20background%2C%20stylized%20painterly%20illustration%20with%20minimal%20detail%2C%20mysterious%20anonymous%20mood%2C%20muted%20terracotta%20and%20rose%20tones%2C%20high%20fashion%20editorial%20photography%20feel%2C%20ample%20negative%20space%2C%20refined%20understated%20composition&width=900&height=1200&seq=dolly-hero-01&orientation=portrait"
                alt="玩偶姐姐人物专题封面插画"
                title="玩偶姐姐 · 专题封面"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent"></div>
              <figcaption className="absolute left-5 bottom-5 right-5">
                <span className="text-[11px] tracking-[0.3em] text-background-100 uppercase">Cover Story</span>
                <p className="mt-1 font-heading text-lg md:text-xl text-background-50 font-semibold">匿名之下，一个被反复讨论的名字</p>
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
}